module.exports = {
  homepage: {
    heroTitle1: "SmartTeamDev",
    heroTitle2: "",
    heroSubtitle: "Проектируем, внедряем и сопровождаем цифровые системы для ежедневной работы сотрудников: документооборот, интеграции, автоматизация и аналитика.",
    marqueeText: "Надёжность • Безопасность • Поддержка • Порталы • Облака • Сеть • Интеграции •",
    heroPrimaryBtn: "Обсудить проект",
    heroPrimaryHref: "/pages/contact",
    heroSecondaryBtn: "Презентация портала",
    heroSecondaryHref: "/pages/presentation-app",
    btnLearnPortal: "Страница Portal",
    btnContact: "Связаться",
    scrollDown: "Подробнее",
    whatYouGetEyebrow: "Что вы получаете",
    whatYouGetTitle: "Готовые решения, которые ускоряют работу команды",
    whatYouGetDesc: "Мы делаем проекты, которые легко внедряются, масштабируются и работают без простоев.",
    card1Title1: "Портал как центр управления",
    card1Desc1: "Единая точка доступа для сотрудников, бизнес-подразделений и внешних партнёров.",
    card1Title2: "Автоматизация задач",
    card1Desc2: "Сценарии, уведомления и ответы на события работают сами, пока вы развиваете бизнес.",
    card1Back: "Измеримые результаты: меньше ручной работы, быстрее решения, прозрачный контроль.",
    card2Title1: "Сеть, которая не подводит",
    card2Desc1: "Продуманная архитектура для стабильной и защищённой корпоративной инфраструктуры.",
    card2Title2: "Облако и гибрид",
    card2Desc2: "Гибкие решения, которые работают и в облаке, и в локальной среде.",
    card2Back: "Поддержка на всех этапах: от запуска до масштабирования и сопровождения.",
    card3Title1: "Безопасность и контроль",
    card3Desc1: "Продвинутый подход к доступам, шифрованию и IT-комплаенсу.",
    card3Title2: "Адаптивная поддержка",
    card3Desc2: "Решения, которые растут вместе с бизнесом и выдерживают изменения требований.",
    card3Back: "Структура, на которую можно опереться: стабильность, доступность и предсказуемость.",
    servicesEyebrow: "Услуги",
    servicesTitle: "Что мы делаем лучше всего",
    servicesDesc: "Комплексный подход: порталы, сервисы, сеть и облачные платформы для роста компании.",
    service1Title: "Корпоративные порталы",
    service1Desc: "Надёжные интерфейсы для внутренних процессов, клиента и партнёров.",
    service2Title: "Облачные платформы",
    service2Desc: "Гибридные и облачные решения с управляемой миграцией и снижением рисков.",
    service3Title: "Информационная безопасность",
    service3Desc: "Защита данных, контроль доступа и соответствие требованиям инфраструктуры.",
    contactEyebrow: "Свяжитесь с нами",
    contactTitle: "Расскажите о задаче, мы предложим решение",
    contactDesc: "Проектируем архитектуру, готовую к изменениям, без лишнего технического долга.",
    contactHighlight1Value: "18 лет",
    contactHighlight1Label: "опыта в корпоративных решениях",
    contactHighlight2Value: "24/7",
    contactHighlight2Label: "мониторинг и поддержка",
    placeholderName: "Имя",
    placeholderEmail: "Email",
    placeholderPhone: "Телефон",
    placeholderMessage: "Опишите задачу",
    contactBtn: "Отправить запрос",
    heroStats: [
      { riIcon: "RiBriefcase4Line", value: "35+", count: 35, label: "Бизнес-приложений" },
      { riIcon: "RiPlugLine", value: "10+", count: 10, label: "Интеграционных контуров" },
      { riIcon: "RiServerLine", value: "On-premise", label: "Развертывание" },
      { riIcon: "RiShieldCheckLine", value: "Role-based", label: "Контроль доступа" }
    ],
    aboutTitle: "Кто мы",
    aboutLead: "SmartTeamDev — команда разработчиков корпоративных веб-систем для промышленных предприятий.",
    aboutText: "Мы создаём и внедряем цифровые инструменты, которые работают в инфраструктуре клиента: on-premise порталы, бизнес-приложения, интеграции и сервисы. Наша специализация — производственные компании, где важны надёжность, контроль данных и гибкость.",
    aboutPoints: [
      "Команда полного цикла: аналитика, разработка, внедрение, поддержка",
      "Работаем on-premise — данные остаются у вас",
      "Специализация на производственных и промышленных предприятиях",
      "Собственная платформа Portal с 35+ готовыми приложениями"
    ],
    areasTitle: "Что мы делаем",
    areasSubtitle: "Три рабочих направления, которые закрывают полный цикл цифровизации",
    companyAreas: [
      {
        href: "/pages/portal",
        riIcon: "RiLayoutGridLine",
        title: "Корпоративный портал",
        description: "Единая рабочая среда для подразделений: документы, задачи, данные и сервисы в одном интерфейсе.",
        features: ["Рабочий стол /app", "Ролевая модель AD", "Модульная структура apps/*"]
      },
      {
        href: "/pages/services",
        riIcon: "RiPlug2Line",
        title: "Разработка и интеграции",
        description: "Подключаем 1С, банки, AD, СКУД, FortMonitor, мессенджеры и внешние API в единый контур.",
        features: ["REST и прокси-интеграции", "Синхронизация по расписанию", "Журналы и аудит"]
      },
      {
        href: "/pages/media",
        riIcon: "RiFileList3Line",
        title: "Демо и документация",
        description: "Показываем реальные сценарии и архитектурные решения по конкретным модулям и ролям.",
        features: ["Демо-сценарии", "Технические материалы", "План внедрения"]
      }
    ],
    factsTitle: "Почему выбирают SmartTeamDev",
    factsSubtitle: "Критерии, важные для эксплуатации в промышленной среде",
    companyFacts: [
      {
        riIcon: "RiLock2Line",
        title: "Контроль данных",
        description: "Система работает в вашем контуре, без обязательных облачных сервисов и внешнего хранения."
      },
      {
        riIcon: "RiStackLine",
        title: "Расширяемая архитектура",
        description: "Новые модули подключаются через декларативную конфигурацию без переписывания всей платформы."
      },
      {
        riIcon: "RiShieldCheckLine",
        title: "Прозрачные права",
        description: "Доступ ограничивается ролями, группами AD и серверными фильтрами на уровне приложений и БД."
      },
      {
        riIcon: "RiSettings3Line",
        title: "Сопровождение",
        description: "Берем на себя обновления, доработки и эксплуатационную поддержку после запуска."
      }
    ],
    releaseTitle: "Как мы выводим проект в эксплуатацию",
    releaseSteps: [
      {
        num: "01",
        riIcon: "RiSearchLine",
        title: "Обследование",
        text: "Фиксируем процессы, роли пользователей, источники данных и обязательные интеграции."
      },
      {
        num: "02",
        riIcon: "RiGitMergeLine",
        title: "Проектирование",
        text: "Готовим структуру модулей, схему прав, модель обмена и регламент запуска."
      },
      {
        num: "03",
        riIcon: "RiServerLine",
        title: "Внедрение",
        text: "Разворачиваем платформу, переносим настройки, подключаем сервисы и обучаем команду."
      },
      {
        num: "04",
        riIcon: "RiPulseLine",
        title: "Сопровождение",
        text: "Обеспечиваем стабильную работу, плановые обновления и развитие функциональности."
      }
    ],
    techTitle: "Технологический стек",
    techSubtitle: "Компоненты платформы, которые используются в промышленной эксплуатации",
    techStack: [
      {
        riIcon: "RiReactjsLine",
        title: "Frontend",
        text: "React 18, Redux Toolkit, Ant Design 5, маршрутизация и виджеты рабочего стола."
      },
      {
        riIcon: "RiNodejsLine",
        title: "Backend",
        text: "Node.js 20+, Express, socket.io, EJS и прикладные API для модулей apps/*."
      },
      {
        riIcon: "RiDatabase2Line",
        title: "Данные",
        text: "MongoDB с разделением системного и бизнес-контуров, Mongoose и серверные фильтры доступа."
      },
      {
        riIcon: "RiSettings4Line",
        title: "Интеграции",
        text: "AD/LDAP, 1С, банковские API, DaData, Контур.Фокус, FortMonitor, WOPI и OpenAI."
      }
    ],
    ctaTitle: "Обсудить ваш проект",
    ctaSubtitle: "Подготовим структуру внедрения, список модулей и план интеграций под вашу организацию.",
    ctaContactBtn: "Написать нам",
    ctaLearnMoreBtn: "Перейти в Portal"
  }
};
